import React, { useState } from 'react'

import { RouteNames } from '../../../../router'
import { Logo } from '../../../../assets/svgs/landingV2/guest'
import { HBurgerExit, HBurgerMenu } from '../../../../assets/svgs/landingV2/business'

import './styles.scss'
import './responsiveStyles.scss'

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  return (
    <div className='bl_header'>
      <div className='bl_header__top'>
        <div className='bl_header__top_logo'>
          <a href='/'>
            <img src={Logo} alt='Pinka logo' />
          </a>
        </div>
        <div className='bl_header__top_buttons'>
          <div className='bl_header__top_buttons_left'>
            <ul>
              <li>
                <a href='#howitworks'>Як це працює</a>
              </li>
              <li>
                <a href='#features'>Можливості</a>
              </li>
              <li>
                <a href='#howtojoin'>Як долучитись</a>
              </li>
              <li>
                <a href='#ourapps'>Наші застосунки</a>
              </li>
            </ul>
          </div>
          <div className='bl_header__top_buttons_right'>
            <div className='bl_header__top_buttons_right_secondary'>
              <a href={RouteNames.ADMIN}>Увійти</a>
            </div>
            <div className='bl_header__top_buttons_right_primary'>
              <a href={RouteNames.ROOT}>Для гостей</a>
            </div>
            <div className='bl_header__top_buttons_right_burger'>
              <img src={HBurgerMenu} onClick={() => setIsMenuOpen(true)} />
            </div>
          </div>
        </div>
        {isMenuOpen && (
          <div className='bl_header__top_menu_overlay'>
            <div className='bl_header__top_menu'>
              <div className='bl_header__top_menu_top'>
                <div className='bl_header__top_logo'>
                  <a href='/'>
                    <img src={Logo} alt='Pinka logo' />
                  </a>
                </div>
                <div className='bl_header__top_buttons'>
                  <div className='bl_header__top_buttons_left'></div>
                  <div className='bl_header__top_buttons_right'>
                    <div className='bl_header__top_buttons_right_primary'>
                      <a href={RouteNames.ROOT}>Для гостей</a>
                    </div>
                    <img src={HBurgerExit} onClick={() => setIsMenuOpen(false)} />
                  </div>
                </div>
              </div>
              <div className='bl_header__top_menu_bottom'>
                <div className='bl_header__top_menu_bottom_links'>
                  <a
                    className='bl_header__top_menu_bottom_links_item'
                    href='#howitworks'
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Як це працює
                  </a>
                  <a
                    className='bl_header__top_menu_bottom_links_item'
                    href='#features'
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Можливості
                  </a>
                  <a
                    className='bl_header__top_menu_bottom_links_item'
                    href='#howtojoin'
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Як долучитись
                  </a>
                  <a
                    className='bl_header__top_menu_bottom_links_item'
                    href='#ourapps'
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Наші застосунки
                  </a>
                </div>
                <div className='bl_header__top_menu_bottom_button'>
                  <a href={RouteNames.ADMIN}>Увійти</a>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className='bl_header__content'>
        <h1>Автоматизація замовлень і збільшення продажів в кав&apos;ярнях</h1>
        <p>
          Ми приклали максимум зусиль, щоб власники кав&apos;ярень надавали найкраще обслуговування для своїх
          відвідувачів і підвищували імідж свого закладу.
        </p>
        <div className='bl_header__content_buttons'>
          <div className='bl_header__content_buttons_secondary'>
            <a href={RouteNames.ADMIN}>Увійти</a>
          </div>
          <div className='bl_header__content_buttons_primary'>
            <a href={RouteNames.SIGNUP}>Зареєструватись</a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Header
